import english from './english';

export const locales = {
  [english.$id]: english
};

export default locales;
